import styled from 'styled-components'

export const ContainerHome = styled.div`
    padding-top: 3.5rem;
    height: 770px;
    .bg {
        position: absolute;
        z-index: -1;
        max-width: 100vw;
        height: 780px;
        right: 0;
        object-fit: contain;
        object-position: 20% -60px;
    }

    .title {
        color: var(--text-title);
        margin-left: 5vw;
        font-size: calc(32px + 4vw);
        margin-top: 10vh;
    }

    .rectangle {
        background-color: var(--bottom);
        border: 2px solid white;
        max-width: 568px;
        width: calc(300px + 16vw);
        padding: 10px 0;
        margin: 32px 0 10px 5vw;
        text-align: center;
        font-family: Moby;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
    }

    .subtitle {
            color: var(--text-body);
            margin-left: 5vw;
            margin-top: 100px;
            font-weight: 700;
            font-family: 'Graphik';
            font-size: calc(16px + 0.4vw);
            width: 80%;
            max-width: 500px;
            text-align: justify;
        p + p {
            color: var(--aqua);
            margin-top: 2rem;
            max-width: 600px;
            min-width: 200px;
        }
        
    }

    @media (min-width:2560px) {
        height: 920px;
        .subtitle p {
            width: 600px;
        }
    }
    
    @media only screen and (max-width: 1440px) {
        .bg {
            object-position: 20% -10px;
        }

        .rectangle {
            margin-left: 5vw;
            width: calc(200px + 12vw);
            font-size: calc(8px + 1vw);
        }

        .subtitle {
            font-size: calc(16px + 0.2vw);
        }
    }

    @media only screen and (max-width: 1024px) {
        height: 567px;
    }

    @media only screen and (max-width: 990px) {
        .title{
            font-size: calc(32px + 4vw);
            margin-left: 5vw;
        }
        .rectangle{
            margin-left: 5vw;
            width: calc(200px + 12vw);
            font-size: calc(8px + 1vw);
        }
        .subtitle p{
            margin-left: 2rem;
        }
    }

    @media(max-width: 768px) {
        height: 480px;
        .title, .rectangle {
            margin-left: 3rem;
        }
        .subtitle {
            margin-left: 1rem;
        }
    }

    @media(max-width: 720px) {
        height: 680px;
    }

    @media(max-width: 425px) {
        height: 600px;
        .title, .rectangle {
            margin-left: 1rem;
        }
        .subtitle {
            margin-left: 0;
        }
    }
    
    @media (max-width: 375px){
        height: 650px;
    }

    @media (max-width: 320px){
        .title {
            font-size: calc(25px + 4vw);
        }
    }
    

`